import React from 'react';
import { Modal } from './Modal';
import GradientButton from './GradientButton';
import { X } from 'lucide-react';

interface ProUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  description: string;
}

export const ProUpgradeModal: React.FC<ProUpgradeModalProps> = ({ isOpen, onClose, description }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-51 w-full py-3 px-9 max-w-[560px] bg-[#111113] rounded-lg text-center">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-[#e7e7e7] bg-transparent border-none rounded-md hover:bg-white/10 transition-colors"
        >
          <X size={16} />
        </button>
        {/* diamond icon */}
        <div className="mb-6 mt-5 flex justify-center items-center">
          <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.00002 0H22.5L28.35 8.355L14.25 28.5L0.150024 8.355L6.00002 0ZM12.24 1.5L9.69002 7.5H18.81L16.26 1.5H12.24ZM9.49502 9L14.25 23.64L19.005 9H9.49502ZM2.58002 7.5H8.07002L10.62 1.5H6.75002L2.58002 7.5ZM2.43002 9L12.66 23.625L7.92002 9H2.43002ZM25.92 7.5L21.75 1.5H17.88L20.43 7.5H25.92ZM26.07 9H20.58L15.84 23.625L26.07 9Z"
              fill="white"
            />
          </svg>
        </div>
        {/* Title */}
        <h2 className="text-white text-2xl font-semibold mb-5 ">Time to go Pro</h2>
        {/* Subtitle */}
        <p className="text-[#A1A1AA] text-lg mb-8">{description}</p>
        {/* Upgrade Button */}
        <GradientButton
          onClick={() => {
            const token = localStorage.getItem('dualitex-alpha-access-token');
            window.location.href = `/billing?token=${token}`;
          }}
          customStyles={{ width: '100%', height: 48, fontSize: 18, fontWeight: 500, marginBottom: 32 }}
        >
          Upgrade
        </GradientButton>
        {/* Talk to us */}
        <div className="text-center mb-5">
          <span className="text-gray-300 text-base">Still not convinced?</span>{' '}
          <button
            className="text-white underline text-base hover:text-blue-400 transition-colors"
            style={{ textUnderlineOffset: 3 }}
            onClick={() => {
              window.open('https://calendly.com/singhvirohan/dualite-feedback', '_blank');
            }}
            type="button"
          >
            Talk to us
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ProUpgradeModal;
